import { WeekDaysEnums } from 'src/shared/enums';
import { useTranslate } from 'src/shared/providers';
import { IMapperRecord } from 'src/shared/utils';

export const useDateTimeLabels = () => {
  const { t } = useTranslate();

  const mapWeekDaysEnumsToFullLabel: IMapperRecord<string> = {
    [WeekDaysEnums.SUNDAY]: t('global.sunday'),
    [WeekDaysEnums.MONDAY]: t('global.monday'),
    [WeekDaysEnums.TUESDAY]: t('global.tuesday'),
    [WeekDaysEnums.WEDNESDAY]: t('global.wednesday'),
    [WeekDaysEnums.THURSDAY]: t('global.thursday'),
    [WeekDaysEnums.FRIDAY]: t('global.friday'),
    [WeekDaysEnums.SATURDAY]: t('global.saturday'),
  };

  return { mapWeekDaysEnumsToFullLabel };
};
